export default "__VITE_ASSET__CGPhW3bP__"